import styled from "styled-components/macro";

export const Container = styled.div`
  margin-bottom: 1em;

  .addStepRow {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .addStepHint {
    margin: 0;
    color: var(--grey-1);
    font-size: 16px;
    line-height: 1.2;
  }

  .reviewMeta {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .metaRow {
    display: grid;
    grid-template-columns: minmax(200px, 320px) minmax(0, 1fr);
    gap: 24px;
    align-items: center;
  }

  .metaRow--top {
    align-items: start;
  }

  .metaLabel {
    margin: 0;
    font-weight: 500;
    line-height: 1.3;
    color: var(--grey-1);
  }

  .metaLabel--align-control {
    margin-top: 16px;
  }

  .metaLabel--align-audience {
    margin-top: 6px;
  }

  .metaLabel--align-category {
    margin-top: 16px;
  }

  .metaField,
  .metaControl {
    min-width: 0;
    width: 100%;

    label {
      margin-bottom: 0;
      width: 100%;
    }

    textarea,
    input {
      width: 100%;
      padding: 16px;
    }
  }

  .metaLargeTextarea {
    padding: 16px !important;
    line-height: 1.55 !important;
  }

  .metaField .error,
  .metaControl .error {
    margin-top: 8px;
  }

  .metaSelectOptionContent {
    display: flex;
    flex-direction: column;
    gap: 2px;
    line-height: 1.2;
  }

  .metaSelectOptionLabel {
    color: var(--grey-0);
    font-weight: 500;
  }

  .metaSelectOptionDescription {
    color: var(--grey-1);
    font-size: 0.82rem;
    line-height: 1.25;
  }

  .instructionsSectionHeading {
    margin: 44px 0 18px;
    font-size: 1.35rem;
    line-height: 1.3;
    font-weight: 600;
  }

  @media (max-width: 900px) {
    .addStepRow {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }

    .metaRow {
      grid-template-columns: 1fr;
      gap: 8px;
    }

    .metaLabel {
      padding-top: 0;
    }

    .metaLabel--align-control,
    .metaLabel--align-audience,
    .metaLabel--align-category {
      margin-top: 0;
    }
  }
`;
